var exports = {
  "I": "x234b8571--490c70--comment",
  "N": "x234b8571--490c70--type",
};

module.exports = exports;
